import _ from 'underscore';
import template from '../../extranet/templates/icon.html';

_.template.icon = function(icon, size, classes) {
	size = size || 's';
	classes = classes || '';

	return _.template(template)({
		icon: icon,
		size: size,
		classes: classes
	});
};
